import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as widgetsActions from "../../../../redux/Widgets/actions";
import Pyramid from "../../../../components/Charts/Pyramid";
import numeral from 'numeral';
import ViewReportLink from "../ViewReportLink.js";
import {isNullOrEmptyArray} from "../../../../utils/general.js";
const widgetName = "FundsList";

const FundsList = props => {
	const widget = useSelector(state => state.widget).widgets[widgetName];
	const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();

	const getOrder = type => {
		switch(type) {
			case "Outreach":
				return 0;
			case "Qualification":
				return 1;
			case "Cloud Engagement":
				return 2;
			case "Customer Intro":
				return 3;
			case "Customer Engagement":
				return 4;
			case "POV":
				return 5;
			case "Proposal/Price Quote":
				return 6;
		}
	};

	useEffect(() => {
		const load = async () => {
			await dispatch(widgetsActions.loadWidget(widgetName))
		};
		load();
	}, [user]);

	const loading = widget == null || widget.status === "loading" || widget.data == null || widget.data.data == null ;

	if(loading) {
		return (
			<div />
		)
	}

	const result = {};
	widget.data.data.forEach(fund => {
		if(!result[fund.Status__c]) {
			result[fund.Status__c] = fund.Amount__c;
		}
		else {
			result[fund.Status__c]++;
		}
	});

	const colors = ["#40A0C1", "#237389", "#126480", "#FFC267", "#FF9E67", "#F37249", "#BF533B", "#FF9090", "#E2E7ED"];

	const items = Object.keys(result).map(k => ({type: k, order: getOrder(k), value: result[k]}));
	let total = 0;
	items.forEach(item => total += item.value);
	items.forEach(item => item.percent = (Math.round(item.value / total * 10000) / 100));

	const layers = items
		.sort((a, b) => a.order - b.order)
		.map((item, i) => ({
			label: `${numeral(item.value).format()} (${item.percent}%)`,
			legendLabel: `${item.type} ${numeral(item.value).format()} (${item.percent}%)`,
			color: colors[i],
			value: item.value
		}));

	return (
		<div className="widget-container">
			<div className="widget-title">Funds Pipeline ({numeral(total).format()})</div>
			{
				isNullOrEmptyArray(layers) ?
					<div style={{textAlign: 'center'}}>No Data</div>
					:
					<>
						<Pyramid data={layers} width={270} height={450} />
						<ViewReportLink onClick={() => props.showReport(widget)} />
					</>
			}
		</div>
	)
};

export default FundsList;